import React from 'react';
import PropTypes from 'prop-types';
import { generateGridStyles } from '../components/helpers';

const Color = ({ val, getHandlers, gridStyles, name }) => {
    const { classes, existSt } = generateGridStyles(gridStyles, name);
    if (Boolean(val)) {
        return (
            <p
                {...getHandlers(false)}
                className={classes.wrapper}
                style={
                    existSt('wrapper')
                        ? {
                              ...existSt('wrapper'),
                              'background-color': val
                          }
                        : {}
                }
            ></p>
        );
    }
};
Color.propTypes = {
    getHandlers: PropTypes.func,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
};
export default Color;
